import { render, staticRenderFns } from "./InputerCptsTransaction.vue?vue&type=template&id=1ca8255f"
import script from "./InputerCptsTransaction.vue?vue&type=script&lang=js"
export * from "./InputerCptsTransaction.vue?vue&type=script&lang=js"
import style0 from "./InputerCptsTransaction.vue?vue&type=style&index=0&id=1ca8255f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports